import Icon from '../components/Icon.vue'

Icon.register({
  adjust: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM256 440c101.7 0 184-82.3 184-184 0-101.7-82.3-184-184-184v368z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/adjust.js
// module id = 589
// module chunks = 0